export const STATUS_CODES = {
  DRAFT: 'DRAFT',
  SEND_SUCCESS: 'SEND_SUCCESS',
  SEND_ERROR: 'SEND_ERROR',
};

export const STATUS_TITLES: Record<string, string> = {
  [STATUS_CODES.DRAFT]: 'Черновик',
  [STATUS_CODES.SEND_SUCCESS]: 'Запрос отправлен успешно',
  [STATUS_CODES.SEND_ERROR]: 'Запрос отправлен с ошибкой',
};